const headerStyles = {
  appBar: {
    backgroundColor: "white",
    color: "black",
    boxShadow: "none",
    borderBottom: "1px solid #ddd",
    position: "fixed",
    zIndex: "999",
    top: "0",
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    minHeight: "72px",
  },
};

export default headerStyles;
